import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transactions-overview',
  templateUrl: './transactions-overview.component.html',
  styleUrls: ['./transactions-overview.component.less'],
})
export class TransactionsOverviewComponent {
  constructor() {}
}
